<template>
    <div>
        <kendo-tabstrip v-if="model">
            <ul>
                <li class="k-state-active">{{ $t('tasks.details') }}</li>
                <li>{{ $t('tasks.history') }}</li>
                <li>{{ $t('tasks.answer') }}</li>
            </ul>
            <div>
                <div class="row">
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.title')}}</label>
                        <div>{{model.title}}</div>
                    </div>
                    <div class="col-md-12 form-group">
                        <label class="font-weight-bold">{{$t('tasks.text')}}</label>
                        <div>{{model.text}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.assigner')}}</label>
                        <div>{{model.assigner}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.assignees')}}</label>
                        <div>{{model.assignees.map(el => el.name).join(', ')}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.status')}}</label>
                        <div>{{model.status}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.type')}}</label>
                        <div>{{model.type}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.priority')}}</label>
                        <div>{{model.priority}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.category')}}</label>
                        <div>{{model.category}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.activity')}}</label>
                        <div>{{model.activity}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.deadline')}}</label>
                        <div>{{ model.deadline ? $moment(model.deadline).format('DD.MM.YYYY HH:mm') : '' }}</div>
                    </div>
                    <div class="col-md-12 bmd-form-group" v-if="model.attachments">
                        <div class="font-weight-bold">{{$t('tasks.attachment')}}</div>
                        <div v-for="(item, index) in model.attachments" :key="index">
                            <file-crud :file="item"
                                        :readonly="true"
                                        :showDescription="false"
                                        :type="item.docTypeCode">
                            </file-crud>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="show">
                    <history :taskId="model.id"></history>
                </div>
            </div>
            <div>
                <div v-if="show">
                    <result :taskId="model.id"></result>
                </div>
            </div>
        </kendo-tabstrip>
    </div>
</template>

<script>
    import FileCrud from '../common/FileCRUD';
    import history from './history';
    import result from './result';

    export default {
        components: {
            FileCrud,
            history,
            result
        },
        props: {
            model: {
                type: Object,
                default() {
                    return null
                }
            },
            show: {
                type: Boolean,
                required: false
            }
        }
    };
</script>
